import React from 'react';

const Marktplatz = React.createClass({
    render: function() {
        return (
            <span className="mplglogo">
                Technische Umsetzung durch:
                <a href="http://www.marktplatz-agentur.de">
                    <img src="/images/MPA-logo-fallback.svg" />
                </a>
            </span>
        );
    }
});

export default Marktplatz;



// WEBPACK FOOTER //
// ./src/js/components/Marktplatz.js